import { SendOTPRequest } from '../api/otp/sendotp/sendotprequest';
import { SendOTPResponse, SendOTPResponseDtoImpl } from '../api/otp/sendotp/sendotpresponse';
import { APIFeatures } from '../util/apifeatures';
import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { StatusCodes } from '../util/statuscodes';
import { SendOTPBuilder } from '../dto/otp/sendotp/sendotpbuilder';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';

export class SendOTPAPIProcessorImpl extends APIProcessorImpl<SendOTPRequest, SendOTPResponse>
{
    onSuccess(responseMapper: ResponseMapper): void 
    {
        try{
            
            if(+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
            {
                if(responseMapper.getStatusCodeOutside() === "SC0000" ||
                responseMapper.getResponseMap().respCode === "000" 
                            || responseMapper.getResponseMap().respCode === "SC0000")
                            {
                                let response = new SendOTPResponseDtoImpl(APIFeatures.SEND_OTP , this.getContext().getResources().getString(Strings.valid_subscriber));
                                response.setSendOTPDto(new SendOTPBuilder(responseMapper.getResponseMap()).buildAll());
            
                                this.getAPISuccess(response);
                            }
                else if(responseMapper.getResponseMap().respCode === "100")
                {
                    let subscriberValidationResponse = new SendOTPResponseDtoImpl(APIFeatures.SEND_OTP, this.getContext().getResources().getString(Strings.subscriber_not_registered));
    
                    this.getAPIFailure(subscriberValidationResponse);   
                }
                else if(responseMapper.getResponseMap().respCode === "002")
                {//password expired/ blocked by admin
                    let subscriberValidationResponse = new SendOTPResponseDtoImpl(
                    APIFeatures.SEND_OTP, this.getContext().getResources().getString(Strings.password_blocked));
    
                    this.getAPIFailure(subscriberValidationResponse);
                }
                else
                {
                    //not -registered, not-etisalath
                    let subscriberValidationResponse = new SendOTPResponseDtoImpl(
                        APIFeatures.SEND_OTP, this.getContext().getResources().getString(Strings.invalid_mpt_subscriber));
        
                        this.getAPIFailure(subscriberValidationResponse);
                }
               
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new SendOTPResponseDtoImpl(APIFeatures.SEND_OTP, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new SendOTPResponseDtoImpl(APIFeatures.SEND_OTP, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch(e)
        {
            this.getAPIFailure(new SendOTPResponseDtoImpl(APIFeatures.SEND_OTP, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }
    
    onFailure(responseMapper: ResponseMapper): void 
    {
        this.getAPIFailure(new SendOTPResponseDtoImpl(APIFeatures.SEND_OTP, responseMapper.getStatusMsg()));
        //   if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
        //     {
        //         if(responseMapper.getResponseMap().data.responseMap.respCode === "100")
        //         {
        //             let response = new SendOTPResponseDtoImpl(APIFeatures.SEND_OTP , this.getContext().getResources().getString(Strings.valid_subscriber));
        //             response.setSendOTPDto(new SendOTPBuilder(responseMapper.getResponseMap()).buildAll());

        //             this.getAPISuccess(response);
        //         }
        //         else
        //         {
        //             this.getAPIFailure(new SendOTPResponseDtoImpl(APIFeatures.SEND_OTP, responseMapper.getStatusMsg()));
        //         }
        //     }
        //     else
        //     {
        //     }
    }   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/sendotpapiprocessor.tsx